export default __webpack_public_path__ + "static/cert2-37e9b9189f1f387526a8fdc0d985ee12.jpg";